import React from 'react';
import classNames from 'classnames';

import InputAdornment from "@material-ui/core/InputAdornment";
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { FaInfoCircle } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';

//import STACK_CONFIG from '../../../config/FormComponents/BuildStack.json'

const formControlStyle = {minWidth: '80px', maxWidth: '10%'}
const seperationLineStyle = {borderTop: '2px solid black', minWidth: '80px', maxWidth: '1364px'}

/*
Args
    classes: Classes for React CSS
    handleInputChange: Function which updates the state in the Form based on user inputs
    stackIDs: Array; held in the forms state of the different stack ID numbers
    stack: Object; set of variables for a stack ID
    stackType: String; the name of the stack, this must match the variable name of the stack
    createStack: Function; the function which adds a new stack based on the stackType
    title: String; the bolded name to be displayed to the user in the UI
    showStackSeperation: String (true or false); controls whether a 2px thick line in shown between each stack
    required: String (true or false); controls whether the form can be submitted without input values
    tooltip: String; information which may help the user complete the form
*/

const BuildStacks = props => {

    return (
    <div className="form-input-container">
        <div>
            <b>{props.title}</b> {props.tooltip && <FaInfoCircle data-tip data-for={props.stackType}/>}

            <ReactTooltip id={props.stackType} place="right" type="light" effect="solid">
                {props.tooltip}
            </ReactTooltip>
        </div>

        {props.stackIDs.map(stackID => (
            <div key={stackID} >

                {props.showStackSeperation === 'true' &&
                    <div>
                        <div style={seperationLineStyle} className={classNames(props.classes.margin)}></div>
                        <div className={classNames(props.classes.margin)}>Source {stackID}</div>
                    </div>
                }

                {props.stack_config.stack[props.stackType].map(row => (
                    <div key={stackID+row.name}>
                        {row.name !== "Stack Vars" && <div className={classNames(props.classes.margin)}>{row.name}</div>}

                        {row.values.map(option => (
                            <FormControl key={stackID+option.value} style={formControlStyle} className={classNames(props.classes.margin, props.classes.formControl)}>

                                <InputLabel shrink>{option.label}</InputLabel>
                                <Input
                                    required={props.required === 'false' ? true : false}
                                    id={String(stackID)}
                                    value={props.stack[stackID][option.value]}
                                    onChange={props.handleInputChange}
                                    name={option.value}
                                    type={option.type}
                                    inputProps={{stacktype: props.stackType, min:option.min, max:option.max, step:option.step, maxLength:option.maxLength}}
                                    placeholder={option.placeholder}
                                    endAdornment={<InputAdornment position="end">{option.unit}</InputAdornment>}
                                />
                            </FormControl>
                        ))}
                    </div>
                ))}
            </div>
        ))}
        <div>
            <Button
                className={classNames(props.classes.margin, props.classes.textField)}
                variant="outlined"
                color="default"
                stacktype={props.stackType}
                onClick={() => props.createStack(props.stackType)}> Add Another {props.stackType}
            </Button>
            <Button
                className={classNames(props.classes.margin, props.classes.textField)}
                variant="outlined"
                color="default"
                stacktype={props.stackType}
                onClick={() => props.removeStack(props.stackType)}> Remove Last {props.stackType}
            </Button>
        </div>

    </div>
)}
export default BuildStacks;
